export const selectCategories = state => state.categories
